import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var body = designTokenFonts.body,
  mini = designTokenFonts.mini;
var colours = tokens.colors;
export var textFieldWrapper = /*#__PURE__*/css("margin-bottom:4px;position:relative;", media('>=tablet'), "{width:100%;margin-bottom:10px;}");
var input = {
  base: /*#__PURE__*/css("width:100%;padding:9px 44px;border:1px solid ", colours.neutral.medium.default, ";color:", colours.neutral.heavy.default, ";", body, ";border-radius:3px;&:focus{border:2px solid ", colours.neutral.heavy.default, ";}"),
  listing: self => self.base,
  watchlist: self => self.base
};
var inputError = {
  base: /*#__PURE__*/css("border-bottom:2px solid ", colours.critical.trim.default, ";"),
  listing: /*#__PURE__*/css("border:1px solid ", colours.critical.trim.default, ";"),
  watchlist: self => self.listing
};
var errorMessage = {
  base: /*#__PURE__*/css(mini, ";color:", colours.critical.base.default, ";"),
  listing: /*#__PURE__*/css("color:", colours.critical.base.default, ";"),
  watchlist: self => self.listing
};
var icon = {
  base: /*#__PURE__*/css("position:absolute;top:10px;left:14px;color:", colours.neutral.base.default, ";width:21px;height:21px;"),
  listing: {
    name: "1v35xj1",
    styles: "left:8px;"
  },
  watchlist: {
    name: "15urxab",
    styles: "left:8px;top:15px;width:19px;height:19px;"
  }
};
export default appearance => {
  var buildStyle = style => [style.base, typeof style[appearance] === 'function' ? style[appearance](style) : style[appearance]];
  return {
    textFieldWrapper,
    input: buildStyle(input),
    inputError: buildStyle(inputError),
    errorMessage: buildStyle(errorMessage),
    icon: buildStyle(icon)
  };
};